import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, endpoints } from '@environment';

@Injectable({ providedIn: 'root' })
export class GdprService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/${endpoints.v1.gdpr}`;

  export(): Observable<Blob> {
    return this.http.post(
	  `${this.baseUrl}/export`,
	  null,
	  { responseType: 'blob' },
    );
  }
}
